import { formatCommaZeroDp } from "./dataHelpers/formatters";

const createTooltipSchema = (year) => {
  const yearClean = year.toString().slice(-2);
  return [
    {
      label: "Eviction filing rate",
      accessor: `efr-${yearClean}`,
      formatter: (val) => `${val}%`,
    },
    {
      label: "Eviction filings",
      accessor: `ef-${yearClean}`,
      formatter: (val) => formatCommaZeroDp(val),
    },
  ];
};
export default createTooltipSchema;
